module.exports = __webpack_public_path__ + "img/man_3_4.3cf01d9e.png";